<template>
  <div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-select
          v-model="form.tipo"
          label="Tipo"
          class="select-large w-full"
          name="Tipo"
          v-validate="{ required: true }"
          :state="validateState('Tipo')"
          :danger="validateClass('Tipo')"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.label"
            v-for="(item, index) in tiposPessoas"
          />
        </vs-select>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Nome"
          v-model="form.nome"
          name="Nome"
          v-validate="{ required: true }"
          :state="validateState('Nome')"
          :danger="validateClass('Nome')"
        />
      </div>

      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Email"
          v-model="form.email"
          name="Email"
          v-validate="{ required: true, email: true }"
          :state="validateState('Email')"
          :danger="validateClass('Email')"
        />
      </div>
    </div>
    <div class="vx-row" v-if="form.tipo == 'Pessoa Física'">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="CPF"
          v-mask="'###.###.###-##'"
          v-model="cpf"
          name="cpf"
          :disabled="!isCpfCanChange($can('Alterar CPF', 'Associados'))"
          v-validate="{ required: true, min: 14 }"
          :state="validateState('cpf')"
          :danger="validateClass('cpf')"
          autocomplete="off"
          aria-autocomplete="none"
          role="presentation"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="RG"
          v-model="form.rgIe"
          name="RG"
          v-validate="{ required: true }"
          :state="validateState('RG')"
          :danger="validateClass('RG')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Data de Nascimento"
          v-mask="'##/##/####'"
          v-model="form.dataNascimento"
          name="Data de Nascimento"
          v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
          :state="validateState('Data de Nascimento')"
          :danger="validateClass('Data de Nascimento')"
        />
      </div>
    </div>
    <div class="vx-row" v-if="form.tipo == 'Pessoa Jurídica'">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CNPJ"
          v-mask="'##.###.###/####-##'"
          v-model="cpf"
          name="cpf"
          v-validate="{ required: true, min: 18 }"
          :state="validateState('cpf')"
          :danger="validateClass('cpf')"
          :disabled="!isCpfCanChange($can('Alterar CPF', 'Associados'))"
          autocomplete="off"
          aria-autocomplete="none"
          role="presentation"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Inscrição Estadual"
          v-model="form.rgIe"
          name="Inscrição Estadual"
          v-validate="{ required: true }"
          :state="validateState('Inscrição Estadual')"
          :danger="validateClass('Inscrição Estadual')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Representante Legal"
          v-model="form.representanteLegal"
          name="Nome Completo Represente Legal"
          v-validate="{ required: true }"
          :state="validateState('Nome Completo Represente Legal')"
          :danger="validateClass('Nome Completo Represente Legal')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Cpf do Representante"
          v-mask="'###.###.###-##'"
          v-model="form.cpfRepresentante"
          name="Cpf do Representante"
          v-validate="{ required: true, min: 14 }"
          :state="validateState('Cpf do Representante')"
          :danger="validateClass('Cpf do Representante')"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Celular"
          v-mask="'(##) #####-####'"
          v-model="form.celular"
          name="Celular"
          v-validate="{ required: true }"
          :state="validateState('Celular')"
          :danger="validateClass('Celular')"
        />
      </div>

      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Celular Adicional"
          v-mask="'(##) #####-####'"
          v-model="form.celularAdicional"
          name="CelularAdicional"
          :state="validateState('CelularAdicional')"
          :danger="validateClass('CelularAdicional')"
        />
      </div>

      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Telefone"
          v-mask="'(##) #####-####'"
          v-model="form.telefone"
          name="Fixo"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-select
          v-model="form.idRegional"
          label="Regional"
          class="select-large w-full"
          name="Regional"
          v-validate="{ required: true }"
          :state="validateState('Regional')"
          :danger="validateClass('Regional')"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.label"
            v-for="(item, index) in regionais"
          />
        </vs-select>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CNH"
          v-mask="'##########'"
          v-model="form.cnh"
          name="CNH"
          v-validate="{ min: 10 }"
          :state="validateState('CNH')"
          :danger="validateClass('CNH')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-select
          v-model="form.catCnh"
          label="Tipo de CNH"
          class="select-large w-full"
          name="Tipo de CNH"
          :state="validateState('Tipo de CNH')"
          :danger="validateClass('Tipo de CNH')"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.label"
            v-for="(item, index) in tipoDeCarteira"
          />
        </vs-select>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Data de Vencimento CNH"
          v-mask="'##/##/####'"
          v-model="form.dataVencimentoCnh"
          name="Data de Vencimento CNH"
          v-validate="{ date_format: 'dd/MM/yyyy' }"
          :state="validateState('Data de Vencimento CNH')"
          :danger="validateClass('Data de Vencimento CNH')"
        />
      </div>
    </div>
    <div class="vx-row">
      <div
        class="vx-col sm:w-1/3 w-full mb-2"
        v-if="$can('Alterar Status', 'Associados')"
      >
        <vs-select
          v-model="form.idStatus"
          label="Status"
          class="select-large w-full"
          name="Status"
          :state="validateState('Status')"
          :danger="validateClass('Status')"
          @input="selecionaStatus"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.label"
            v-for="(item, index) in situacoes"
          />
        </vs-select>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <span>Cobrança Individualizada por veículo?</span>
        <vs-switch
          color="success"
          v-model="form.boletoIndividual"
          style="width: 60px"
        >
          <span slot="on">Sim</span>
          <span slot="off">Não</span>
        </vs-switch>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <span>Fazer comunicação preventiva do financeiro?</span>
        <vs-switch
          color="success"
          v-model="form.comunicacaoPreventivoFinanceiro"
          style="width: 60px"
        >
          <span slot="on">Sim</span>
          <span slot="off">Não</span>
        </vs-switch>
      </div>
    </div>
    <hr class="my-6" />
    <div class="vx-row">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="CEP"
          v-mask="'##.###-###'"
          v-model="form.cep"
          name="CEP"
          @keyup.native="keymonitor"
          v-validate="{ required: true, min: 10 }"
          :state="validateState('CEP')"
          :danger="validateClass('CEP')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Endereço"
          v-model="form.endereco"
          name="Endereço"
          v-validate="{ required: true }"
          :state="validateState('Endereço')"
          :danger="validateClass('Endereço')"
        />
      </div>
      <div class="vx-col sm:w-1/6 w-full mb-2">
        <vs-input
          class="w-full"
          label="Número"
          v-model="form.numero"
          name="Número"
          v-validate="{ required: true }"
          :state="validateState('Número')"
          :danger="validateClass('Número')"
        />
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          class="w-full"
          label="Complemento"
          v-model="form.complemento"
          name="Complemento"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <vs-input
          class="w-full"
          label="Bairro"
          v-model="form.bairro"
          name="Bairro"
          v-validate="{ required: true }"
          :state="validateState('Bairro')"
          :danger="validateClass('Bairro')"
        />
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <label for="" class="vs-select--label">Estado</label>
        <v-select
          :options="estados"
          name="Estado"
          id="Estado"
          autocomplete="off"
          @input="
            ((cidade = null), (form.cidade = null)),
              buscaDadosSelectsCidades(
                'domMunicipio',
                'cidades',
                'nomeCidade',
                'idCidade',
              ),
              selecionaEstado()
          "
          v-model="estado"
          v-validate="{ required: true }"
          label="label"
          :state="validateState('Estado')"
          :class="validateClass('Estado')"
        ></v-select>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-2">
        <label for="" class="vs-select--label">Cidade</label>
        <v-select
          :options="cidades"
          name="Cidade"
          id="Cidade"
          @input="selecionaCidade()"
          ref="selectCidade"
          v-model="cidade"
          v-validate="{ required: true }"
          label="label"
          :state="validateState('Cidade')"
          :class="validateClass('Cidade')"
        ></v-select>
      </div>
    </div>
  </div>
</template>

<script>
import service from './../../services';
import locale from './../../locale';
import moment from 'moment';
import vSelect from 'vue-select';
import { decryptData } from './../../services/decryptData';

export default {
  components: { 'v-select': vSelect },
  props: ['dadosAssociado', 'formulario', 'regionais'],
  watch: {
    dadosAssociado() {
      this.preencheForm();
    },
    cpf() {
      if (this.cpf) {
        this.form.cpfcnpj = this.cpf;
      }
    },
  },

  data() {
    return {
      tipoDeCarteira: [
        { label: 'Selecione', id: null },
        { label: 'A', id: 'A' },
        { label: 'B', id: 'B' },
        { label: 'C', id: 'C' },
        { label: 'D', id: 'D' },
        { label: 'E', id: 'E' },
        { label: 'AB', id: 'AB' },
        { label: 'AC', id: 'AC' },
        { label: 'AD', id: 'AD' },
        { label: 'AE', id: 'AE' },
      ],
      tiposPessoas: [
        { label: 'Selecione', id: null },
        { label: 'Pessoa Física', id: 'Pessoa Física' },
        { label: 'Pessoa Jurídica', id: 'Pessoa Jurídica' },
      ],
      situacoes: [],
      form: {
        idProposta: null,
        idProspect: null,
        idStatus: null,
        tipo: null,
        nome: null,
        email: null,
        cpfcnpj: null,
        rgIe: null,
        dataNascimento: null,
        representanteLegal: null,
        cpfRepresentante: null,
        idRegional: null,
        telefone: null,
        celular: null,
        cnh: null,
        catCnh: null,
        dataVencimentoCnh: null,
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        estado: null,
        cidade: null,
        boletoIndividual: null,
        unificaAssociado: false,
        cpfDuplicado: false,
        validate: null,
        celularAdicional: null,
        comunicacaoPreventivoFinanceiro: false,
      },
      formVerificaCpf: {},
      cpf: null,
      estados: [],
      cidades: [],
      estado: null,
      cidade: null,
    };
  },
  methods: {
    selecionaStatus(event) {
      var aux = this.situacoes.find((x) => x.id == event);
      this.form.idStatus = aux.id;
      this.form.situacao = aux.label;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    keymonitor: function () {
      if (this.form.cep.length == 10) {
        this.$vs.loading();
        var cepbusca = this.form.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            res.data = decryptData(res.data);
            this.form.endereco = res.data.street;
            this.form.bairro = res.data.neighborhood;
            this.form.cidade = res.data.city;
            this.form.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não Foi possível encontrar o cep',
              color: 'danger',
            });
          });
      }
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    buscaDadosAtivosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .post(model, `list`, {
          idEmpresa: this.idEmpresa,
          notDeleted: true,
          tipoStatus: 'ASSOCIADOS',
        })
        .then((res) => {
          this[array].push({ label: 'Selecione', id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    isCpfCanChange(permissao) {
      let retorno = true;
      if (this.form.situacao) {
        retorno = false;
        if (permissao) retorno = permissao;
      }

      return retorno;
    },
    preencheForm() {
      if (this.formulario.idProspect) {
        this.form = this.formulario.dadosCliente;
        this.cpf = this.formulario.dadosCliente.cpfcnpj;
      } else {
        if (this.dadosAssociado.idProspect) {
          this.form.idProspect = this.dadosAssociado.idProspect;
          this.form.tipo = this.dadosAssociado.tipo;
          this.form.nome = this.dadosAssociado.nome;
          this.form.email = this.dadosAssociado.email;
          this.cpf = this.dadosAssociado.cpfcnpj;
          this.form.dataNascimento = moment(this.dadosAssociado.dataNascimento)
            .utc()
            .format('DD/MM/YYYY');
          this.form.rgIe = this.dadosAssociado.rgIe;
          this.form.cnh = this.dadosAssociado.cnh;
          this.form.catCnh = this.dadosAssociado.catCnh;
          this.form.dataVencimentoCnh = moment(
            this.dadosAssociado.dataVencimentoCnh,
          )
            .utc()
            .format('DD/MM/YYYY');
          this.form.representanteLegal = this.dadosAssociado.representanteLegal;
          this.form.cpfRepresentante = this.dadosAssociado.cpfRepresentante;
          this.form.idRegional = this.dadosAssociado.idRegional;
          this.form.telefone = this.dadosAssociado.telefone;
          this.form.celular =
            this.dadosAssociado.celular == null
              ? this.dadosAssociado.telefone
              : this.dadosAssociado.celular;
          this.form.cep = this.dadosAssociado.cep;
          this.form.endereco = this.dadosAssociado.endereco;
          this.form.numero = this.dadosAssociado.numero;
          this.form.complemento = this.dadosAssociado.complemento;
          this.form.bairro = this.dadosAssociado.bairro;
          this.form.estado = this.dadosAssociado.estado;
          this.estado = this.dadosAssociado.estado;

          this.form.cidade = this.dadosAssociado.cidade;
          this.cidade = this.dadosAssociado.cidade;

          this.form.idStatus = this.dadosAssociado.idStatus;
          this.form.situacao = this.dadosAssociado.situacao;
          this.form.boletoIndividual = this.dadosAssociado.boletoIndividual;
          this.form.celularAdicional = this.dadosAssociado.celularAdicional;
          this.form.comunicacaoPreventivoFinanceiro =
            this.dadosAssociado.comunicacaoPreventivoFinanceiro;
        }
      }
    },
    emitForm() {
      this.$validator.validateAll().then((result) => {
        this.form.validate = result;
        this.$emit('formAlterado', this.form);
      });
    },
    buscaDadosSelectsEstados(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data = decryptData(res.data);
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort((a, b) => {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: 'Selecione' });
      });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado || this.estado.label === 'EX' || !this.estado.id) {
        this[array] = [];
        this.cidade = null;
        this.$refs.selectCidade.open = false;
        return;
      }

      this.$vs.loading();
      this[array] = [];
      if (this.estado && this.estado.id) {
        this.$vs.loading();

        service
          .getAll('g', {}, `${model}/list/codUf/${this.estado.id}`)
          .then(({ data }) => {
            data = decryptData(data);

            if (data)
              data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });

            this.$vs.loading.close();
          });

        if (this.abrirSelectCidade) {
          this.$refs.selectCidade.open = true;
          this.abrirSelectCidade = false;
        }
      }
    },
    selecionaEstado() {
      if (!this.estado) {
        this.cidade = null;
        this.form.cidade = null;
        return;
      }

      this.form.estado = this.estado.label;
    },
    selecionaCidade() {
      if (!this.cidade) {
        this.cidade = null;
        return;
      }

      this.form.cidade = this.cidade.label;
    },
  },
  mounted() {
    this.preencheForm();
    this.buscaDadosAtivosSelectsPorEmpresa(
      'status',
      'situacoes',
      'nomeStatus',
      'idStatus',
    );
    this.$validator.localize('ptBr', locale);

    this.buscaDadosSelectsEstados('domUf', 'estados', 'nomeUf', 'codUf');
    this.buscaDadosSelectsCidades(
      'domMunicipio',
      'cidades',
      'nomeCidade',
      'idCidade',
    );
  },
  created: function () {
    this.$watch('form', this.emitForm, {
      deep: true,
    });
  },
};
</script>
<style>
.vdp-datepicker input {
  width: 100%;
}
</style>
